import DropdownOption from '../../../lib/bootstrap-ui/Dropdown/DropdownOption';

export const getSelectedOptionSuffix = (valueType: DropdownOption) =>
    valueType.value === 'SupplierCode'
        ? `${valueType.label}`
        : `${valueType.label} Name`;
